<span class="payment-method" [class.payment-method--start]="align() === 'start'">
  @if (icon(); as iconName) {
    <img
      class="payment-method__icon"
      [class.payment-method__icon--generic]="isGenericCard()"
      [src]="'assets/icon/' + iconName + '.svg'"
      alt=""
      aria-hidden="true"
    />
  }
  <span class="payment-method__label">{{ 'GOD_ORDERS.METHODS.' + method() | translate }}</span>
</span>
